class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.sectionHeader = document.querySelector('.section-header');
    this.scrollIntentBound = false;
  }

  onToggle() {
    super.onToggle();
    this.updateSectionHeaderState();

    if (!this.header) return;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  updateSectionHeaderState() {
    if (!this.sectionHeader) return;

    const hasOpenDesktopMenu = Boolean(this.sectionHeader.querySelector('header-menu details[open]'));
    this.sectionHeader.classList.toggle('header-menu-open', hasOpenDesktopMenu);

    if (hasOpenDesktopMenu) {
      this.bindScrollIntentListeners();
    } else {
      this.sectionHeader.classList.remove('header-menu-scroll-mode');
      this.unbindScrollIntentListeners();
    }
  }

  bindScrollIntentListeners() {
    if (this.scrollIntentBound) return;

    this.handleWheelScrollIntent = this.handleWheelScrollIntent || this.enableScrollMode.bind(this);
    this.handleTouchScrollIntent = this.handleTouchScrollIntent || this.enableScrollMode.bind(this);
    this.handleKeyboardScrollIntent =
      this.handleKeyboardScrollIntent ||
      ((event) => {
        const scrollKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', 'Space'];
        if (scrollKeys.includes(event.code)) this.enableScrollMode();
      });

    window.addEventListener('wheel', this.handleWheelScrollIntent, { passive: true });
    window.addEventListener('touchmove', this.handleTouchScrollIntent, { passive: true });
    document.addEventListener('keydown', this.handleKeyboardScrollIntent);
    this.scrollIntentBound = true;
  }

  unbindScrollIntentListeners() {
    if (!this.scrollIntentBound) return;

    window.removeEventListener('wheel', this.handleWheelScrollIntent);
    window.removeEventListener('touchmove', this.handleTouchScrollIntent);
    document.removeEventListener('keydown', this.handleKeyboardScrollIntent);
    this.scrollIntentBound = false;
  }

  enableScrollMode() {
    if (!this.sectionHeader) return;
    if (!this.sectionHeader.querySelector('header-menu details[open]')) return;

    this.sectionHeader.classList.add('header-menu-scroll-mode');
  }
}

customElements.define('header-menu', HeaderMenu);
